import * as sessionManager from '$domain/model/session/session.manager'

export const verifyToken = (token: string) => {
  return sessionManager.verifyToken(token)
}



// WEBPACK FOOTER //
// ./src/services/session/verification/verification.service.ts